<template>
  <div v-bind="$attrs">

    <label
      class="checkbox">
      <input
        :disabled="disabled"
        :required="required"
        type="checkbox"
        :checked="value"
        @input="$emit('input', $event.target.checked)">
      <span v-html="label"></span>
    </label>

  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean
    },
    label: {
      type: [String, Number],
      default: null
    },
    required: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  }
}
</script>

<style scoped>
.checkbox span {
  margin-left: 0.3em;
}
</style>
